export const PAGE_VIEWS_COMPS = 'comps';
export const PAGE_VIEWS_THEATRES = 'theatres';
export const PAGE_VIEWS = [PAGE_VIEWS_COMPS, PAGE_VIEWS_THEATRES];
